/**
 * 路由安全跳转Mixin
 * 为所有组件提供安全的路由跳转方法，自动处理NavigationDuplicated错误
 */
export default {
  methods: {
    /**
     * 安全的路由跳转
     * @param {string|Object} route - 目标路由
     * @param {Function} onSuccess - 成功回调
     * @param {Function} onError - 错误回调
     */
    $safeRoutePush(route, onSuccess, onError) {
      this.$router.push(route).then(() => {
        if (onSuccess) onSuccess()
      }).catch(err => {
        if (err.name === 'NavigationDuplicated') {
          console.log('导航重复，已忽略')
          if (onSuccess) onSuccess()
        } else {
          console.error('路由跳转失败:', err)
          if (onError) onError(err)
        }
      })
    },

    /**
     * 安全的路由替换
     * @param {string|Object} route - 目标路由
     * @param {Function} onSuccess - 成功回调
     * @param {Function} onError - 错误回调
     */
    $safeRouteReplace(route, onSuccess, onError) {
      this.$router.replace(route).then(() => {
        if (onSuccess) onSuccess()
      }).catch(err => {
        if (err.name === 'NavigationDuplicated') {
          console.log('导航重复，已忽略')
          if (onSuccess) onSuccess()
        } else {
          console.error('路由替换失败:', err)
          if (onError) onError(err)
        }
      })
    },

    /**
     * 检查当前路由是否与目标路由相同
     * @param {string|Object} route - 目标路由
     * @returns {boolean} - 是否相同
     */
    $isSameRoute(route) {
      if (typeof route === 'string') {
        return this.$route.path === route
      }
      
      if (typeof route === 'object') {
        // 简单的路由对象比较
        if (route.path && route.path !== this.$route.path) {
          return false
        }
        
        if (route.name && route.name !== this.$route.name) {
          return false
        }
        
        // 可以添加更多的比较逻辑
        return true
      }
      
      return false
    }
  }
} 